module.exports = __webpack_public_path__ + "portal-static/img/defaultImage.f57d33f2.png";